import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import TableList from '../../components/TableList';

const defaultParams = {
  defaultSortName: 'refNo',
  defaultSortOrder: 'descending'
};

class PurchasesOrderList extends React.Component {
  static propTypes = {
    ManagePurchaseOrders: PropTypes.any,
    WorkOrderProfile: PropTypes.any,
    rfsId: PropTypes.any,
    workOrderId: PropTypes.any,
    fetchPOList: PropTypes.func,
    isPunchList: PropTypes.bool
  };

  static defaultProps = {
    ManagePurchaseOrders: []
  };

  constructor(props) {
    super(props);

    this.state = {
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,
      currentPage: props.ManagePurchaseOrders.params.skip
    };
  }

  customRenderPOID(item) {
    if (this.props.isPunchList) {
      return (
        <Link
          to={`/punch-lists/punch-list-item/purchase-order/${
            this.props.rfsId
          }/${item.woRefNo}/detail/${item.refNo}`}
        >
          {item.refNo}
        </Link>
      );
    }
    return (
      <Link
        to={`/request-for-services/work-order/purchase-order/${
          this.props.rfsId
        }/${item.woRefNo}/detail/${item.refNo}`}
      >
        {item.refNo}
      </Link>
    );
  }

  customRenderIssuedTo(item) {
    return <span>{item.subcontractor.companyName}</span>;
  }

  customRenderEstimateAmount(item) {
    return this.renderMoney(item.estimatedAmount);
  }

  customRenderActualAmount(item) {
    return this.renderMoney(item.actualAmount);
  }

  renderMoney = value => {
    if (value !== null) {
      return <span>${Number(value).toFixed(2)}</span>;
    }
    return <span>-</span>;
  };

  toolTip() {
    return (
      <Tooltip
        className='in tooltip-siteone po-button-tooltip'
        placement='left'
        id='po-button-new-tooltip'
      >
        <span>
          You need to assign this work order to a subcontractor before adding a
          purchase order.
        </span>
      </Tooltip>
    );
  }

  renderButtonNewPO = WorkOrderProfile => {
    if (
      WorkOrderProfile &&
      WorkOrderProfile.workOrder &&
      WorkOrderProfile.workOrder.woInformation &&
      WorkOrderProfile.workOrder.woInformation.subcontractorProfile &&
      WorkOrderProfile.workOrder.woInformation.status !== 0 &&
      WorkOrderProfile.workOrder.woInformation.status !== 3
    ) {
      if (this.props.isPunchList) {
        return (
          <div className='col-sm-6'>
            <Link
              className='btn btn-primary btn-info btn-siteone pull-right btn-icon'
              to={`/punch-lists/punch-list-item/purchase-order/${
                this.props.rfsId
              }/${this.props.workOrderId}/add`}
            >
              <span className='fa fa-plus icon' />
              NEW
            </Link>
          </div>
        );
      }
      return (
        <div className='col-sm-6'>
          <Link
            className='btn btn-primary btn-info btn-siteone pull-right btn-icon'
            to={`/request-for-services/work-order/purchase-order/${
              this.props.rfsId
            }/${this.props.workOrderId}/add`}
          >
            <span className='fa fa-plus icon' />
            NEW
          </Link>
        </div>
      );
    }

    return (
      <div className='col-sm-6'>
        <OverlayTrigger placement='left' overlay={this.toolTip()}>
          <button className='btn btn-primary btn-disabled btn-siteone pull-right btn-icon'>
            <span className='fa fa-plus icon' />
            NEW
          </button>
        </OverlayTrigger>
      </div>
    );
  };

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage
      },
      () => {
        this.props.fetchPOList({
          sortField: params.defaultSortName,
          sortOrder: params.defaultSortOrder
        });
      }
    );
  }

  refreshPageList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage
      },
      () => {
        this.props.fetchPOList({
          sortField: params.defaultSortName,
          sortOrder: params.defaultSortOrder
        });
      }
    );
  }

  render() {
    const { ManagePurchaseOrders, WorkOrderProfile } = this.props;
    const column = [
      {
        field: 'refNo',
        header: 'PO#',
        hidden: false,
        isKey: true,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left',
        customRender: this.customRenderPOID.bind(this),
        widthStyle: 'name'
      },
      {
        field: 'subcontractor',
        header: 'Issued to',
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left',
        customRender: this.customRenderIssuedTo.bind(this),
        widthStyle: 'address'
      },
      {
        field: 'estimatedAmount',
        header: 'Estimated amt.',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'right',
        headerAlign: 'right',
        customRender: this.customRenderEstimateAmount.bind(this),
        widthStyle: 'name'
      },
      {
        field: 'actualAmount',
        header: 'Actual amt.',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'right',
        headerAlign: 'right',
        customRender: this.customRenderActualAmount.bind(this),
        widthStyle: 'name'
      },
      {
        field: 'reason',
        header: 'Reason',
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left',
        widthStyle: 'address'
      }
    ];

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder // default sort order,
    };

    const tableHeader = (
      <div className='table-header'>
        <div className='row'>
          <div className='col-sm-6'>
            <label>Purchase orders ({ManagePurchaseOrders.items.length})</label>
          </div>
          {this.renderButtonNewPO(WorkOrderProfile)}
        </div>
      </div>
    );

    return (
      <div className='purchases-order-wrapper col-xs-12 col-sm-12'>
        <TableList
          column={column}
          defaultParams={defaultParams}
          data={this.props.ManagePurchaseOrders.items}
          options={options}
          showButtonMenu={true}
          refreshPageList={this.refreshPageList.bind(this)}
          refreshList={this.refreshList.bind(this)}
          customTableHeader={tableHeader}
          ignoreSinglePage
        />
      </div>
    );
  }
}

export default PurchasesOrderList;



// WEBPACK FOOTER //
// ./src/Purchase-Orders/Components/PurchaseOrdersList.js